export default __webpack_public_path__ + "static/media/trash.ce1c2af1.svg";